<div class="page-footer">
    <div class="section">
        <div class="container">
            <div class="footer">
                <div>&nbsp;</div>
                <div>© Pressmind GmbH</div>
            </div>
        </div>
    </div>
</div>
